import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CartonContents } from '@app/store/sorting/models';
import { Box } from '../models';

export const placedBoxesActions = createActionGroup({
    source: 'Placed Boxes',
    events: {
        'Load Boxes': props<{ stationCode: string; page: number }>(),
        'Load Boxes Success': props<{ payload: Box[]; page: number; hasMore: boolean }>(),
        'Load Boxes Error': props<{ code: number }>(),
        'Load Box': props<{ code: string }>(),
        'Load Box Success': props<{ payload: Box }>(),
        'Load Box Error': props<{ code: number }>(),
        'Lock Box': props<{ code: string }>(),
        'Lock Box Success': props<{ payload: CartonContents }>(),
        'Lock Box Error': props<{ code: number; key: string }>(),
        'Unlock Box': emptyProps(),
        'Unlock Box Success': props<{ cartonCode: string }>(),
        'Unlock Box Error': props<{ code: number; cartonCode: string }>(),
        'Reduce Item': props<{ code: string; ean: string }>(),
        'Reduce Item Success': props<{ payload: CartonContents }>(),
        'Reduce Item Error': props<{ code: number; key: string }>(),
        'Increase Item': props<{ code: string; ean: string }>(),
        'Increase Item Success': props<{ payload: CartonContents }>(),
        'Increase Item Error': props<{ code: number; key: string }>(),
        'Close Box': props<{ code: string }>(),
        'Close Box Success': props<{ code: string; payload: CartonContents | null }>(),
        'Close Box Error': props<{ code: number; key: string }>(),
        Clear: emptyProps(),
    },
});
